import React from 'react';
import { COMPANY_NAME_FULL, MAP_EMBED_URL, MAP_SHARE_URL } from '../constants/site';
import './Map.css';

const Map = () => (
  <div className="contact-map-wrap">
    <iframe
      className="map"
      title={COMPANY_NAME_FULL}
      src={MAP_EMBED_URL}
      width="600"
      height="450"
      style={{ border: 0 }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
    <p className="contact-map-wrap__label">{COMPANY_NAME_FULL}</p>
    <a
      className="contact-map-wrap__link"
      href={MAP_SHARE_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      Open in Google Maps
    </a>
  </div>
);

export default Map;
